import { Button } from "@/components/ui/button";
import { trackCTAClick } from "@/utils/analytics";

export default function FinalCTASection() {
  const openJotform = () => {
    trackCTAClick("Final CTA — Get Your Pass Now");
    window.open("https://pci.jotform.com/form/260353574059056", "_blank");
  };

  return (
    <section
      id="final-cta"
      className="py-20 bg-[#0A1A2F] relative overflow-hidden"
      data-testid="final-cta-section"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        {/* Masky - Medium size for kid-friendly section */}
        <div className="mb-8">
          <img
            src="https://customer-assets.emergentagent.com/job_1abea0ec-cded-4678-a29f-de28c813ea65/artifacts/2pfnnew9_bigger%20masky.png"
            alt="Masky waving goodbye"
            className="w-40 sm:w-48 mx-auto masky-glow"
          />
        </div>

        <div className="inline-flex items-center gap-2 bg-[#D4A857]/20 text-[#D4A857] px-4 py-2 rounded text-sm font-bold uppercase tracking-wide mb-6 font-['Montserrat']">
          Ready to Start?
        </div>

        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mb-6 font-['Montserrat']">
          Ready to start their fencing<br />
          <span className="text-[#D4A857]">adventure with Masky?</span>
        </h2>

        <p className="text-xl text-white/80 mb-8 max-w-2xl mx-auto font-['Lato']">
          Give your child the gift of confidence, new friends, and an unforgettable 
          school holiday experience. Spaces are limited!
        </p>

        <Button
          onClick={openJotform}
          size="lg"
          className="bg-[#D4A857] hover:bg-[#C49A4D] text-[#0A1A2F] font-bold text-base sm:text-xl px-6 sm:px-12 py-7 h-auto whitespace-normal max-w-full rounded shadow-lg hover:shadow-xl transition-all hover:scale-105 font-['Montserrat'] uppercase tracking-wide"
          data-testid="final-cta-button"
        >
          Get Your 5-Day Pass — £99
        </Button>

        <p className="text-white/60 mt-6 text-sm font-['Lato']">
          Valid 12 months from purchase • All equipment included • Ages 6-16
        </p>
      </div>
    </section>
  );
}
